import { createSelector } from 'reselect';

import { selectSessionExpirationErrorCode } from './AuthSelectors';
import { WARNING_SOURCES } from '../constants/WarningsConstants';
import { getErrors, getWarnings } from '../form-designer/selectors/common.selectors';

export const getErrorDisplayMessages = createSelector(
  [getErrors, getWarnings, selectSessionExpirationErrorCode],
  (errors, warnings, sessionExpirationErrorCode) => [
    ...errors.filter(
      ({ code, isTopBanner }) => code !== sessionExpirationErrorCode && !isTopBanner
    ),
    ...warnings
      .filter(
        (w) =>
          w.warningEnabled &&
          ![
            WARNING_SOURCES.SERVER,
            WARNING_SOURCES.ASSISTANT,
            WARNING_SOURCES.ARCHIVE_MODE,
          ].includes(w.source)
      )
      .map((w) => ({ ...w, customVariant: 'warning' })),
  ]
);

export const pageHasErrors = createSelector(
  [getErrorDisplayMessages],
  (errorDisplayMessages) => errorDisplayMessages.length > 0
);
